import { makeSafeRequest } from "../../common/makeSafeRequest";
import { ForcePackageData } from "../../types/force-packages";

export const downloadForcePackageSettings = async (systemId: number) => {
	return await makeSafeRequest<ForcePackageData>(`force-packages/${systemId}/`, "GET");
};
